var map = [];

(function ($, window, document) {
    var $win = $(window);
    var $doc = $(document);
    var headerH;
    var group = 1;
    var index = 0;
    var activeClass = "active";

    function mobileView() {
        return $win.outerWidth() < 768;
    }
    function tabletView() {
        return $win.outerWidth() < 1200;
    }

    // Sliders
    function initSliders() {
        // Slider Intro
        // $('.slider-intro').each(function(){
        //     var $slider = $(this);
        //     var $sliderSlides = $slider.find('.slider__slides');
        //     var $sliderDots = $slider.find('.slider__dots');
        //     var $sliderArrows = $slider.find('.slider__arrows');

        //     $sliderSlides.slick();
        // });

        if ($(".jsSliderMain").length) {
            var $sliderMain = $(".jsSliderMain:not(.hidden .jsSliderMain)");

            $sliderMain.each(function () {
                var $slider = $(this);
                var $sliderSlides = $slider.find(".slider__slides");
                var $sliderArrows = $slider.find(".slider__arrows");
                var $sliderDots = $slider.find(".slider__dots");

                // intro has dif args
                if ($slider.hasClass("slider-intro")) {
                    var slider_args = {
                        arrows: false,
                        dots: true,
                        appendDots: $sliderDots,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        autoplay: false,
                        autoplaySpeed: 5000,
                    };
                } else {
                    var showSlides = parseInt($slider.attr("data-slidestoshow"))
                        ? parseInt($slider.attr("data-slidestoshow"))
                        : 1;
                    var autoplaySlides = $slider.attr("data-autoplay")
                        ? $slider.attr("data-autoplay")
                        : false;

                    var slider_args = {
                        arrows: true,
                        appendArrows: $sliderArrows,
                        dots: true,
                        appendDots: $sliderDots,
                        infinite: true,
                        slidesToShow: showSlides,
                        slidesToScroll: 1,
                        speed: 800,
                        responsive: [
                            {
                                breakpoint: 767,
                                settings: {
                                    slidesToShow: 1,
                                    slidesToScroll: 1,
                                },
                            },
                        ],
                    };
                }

                $descSlider = $slider.parent().siblings(".jsSliderDesc");
                if($descSlider.length) {
                    // Reference the actual paired elements (not a generic
                    // ".jsSliderDesc" class-string selector) so each main/
                    // desc pair syncs only with its own partner, in case
                    // more than one such carousel is ever on the same page.
                    slider_args.asNavFor = $descSlider;

                    $descSlider.slick({
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: false,
                        dots: true,
                        appendDots: $descSlider.next(".slider__dots"),
                        fade: true,
                        draggable: false,
                        // Without this, swiping the desc slider only moved
                        // itself - the image slider (asNavFor'd to this one
                        // above) never heard about it. This makes the sync
                        // two-way.
                        asNavFor: $sliderSlides,
                    })
                }

                $sliderSlides.slick(slider_args);

                //if ($slider.hasClass('slider-plans')) {
                $win.on("load", function () {
                    if (
                        $slider
                            .find(".slick-current")
                            .hasClass("slider__slide--light")
                    ) {
                        $slider
                            .find(".slider-controls")
                            .addClass("slider-controls--dark");
                    } else {
                        $slider
                            .find(".slider-controls")
                            .removeClass("slider-controls--dark");
                    }
                });

                $slider
                    .find(".slider__slides")
                    .on(
                        "afterChange",
                        function (event, slick, currentSlide, nextSlide) {
                            if (
                                $slider
                                    .find(".slick-current")
                                    .hasClass("slider__slide--light")
                            ) {
                                $slider
                                    .find(".slider-controls")
                                    .addClass("slider-controls--dark");
                            } else {
                                $slider
                                    .find(".slider-controls")
                                    .removeClass("slider-controls--dark");
                            }
                        }
                    );
                //}
            });
        }

        if ($(".jsSliderAbout").length) {
            var $sliderAbout = $(".jsSliderAbout");

            $sliderAbout.each(function () {
                var $slider = $(this);
                var $sliderSlides = $slider.find(".slider__slides");
                var $sliderArrows = $slider.find(".slider__arrows");
                var $sliderDots = $slider.find(".slider__dots");
                var showSlides = parseInt($slider.attr("data-slidestoshow"))
                    ? parseInt($slider.attr("data-slidestoshow"))
                    : 1;
                var autoplaySlides = $slider.attr("data-autoplay")
                    ? $slider.attr("data-autoplay")
                    : false;

                $sliderSlides.slick({
                    arrows: true,
                    appendArrows: $sliderArrows,
                    dots: true,
                    appendDots: $sliderDots,
                    infinite: true,
                    slidesToShow: showSlides,
                    slidesToScroll: 1,
                    speed: 800,
                    autoplay: false,
                    adaptiveHeight: true,
                    responsive: [
                        {
                            breakpoint: 767,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1,
                            },
                        },
                    ],
                });

                $win.on("load resize", function () {
                    setTimeout(function () {
                        $slider.find(".slider__slides").slick("refresh");
                    }, 1000);
                });
            });
        }

        if ($("body.single .article__content .gallery").length) {
            var $gallery_slider = $("body.single .article__content .gallery");

            $gallery_slider.slick({
                arrows: false,
                //appendArrows: $sliderArrows,
                dots: true,
                //appendDots: $sliderDots,
                infinite: true,
                // slidesToShow: showSlides,
                slide: ".gallery-item",
                slidesToScroll: 1,
                speed: 800,
                autoplay: true,
                autoplaySpeed: 5000,
                adaptiveHeight: true,
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        },
                    },
                ],
            });
        }

        if ($(".jsSliderMobileOnly").length) {
            var $sliderMobileOnly = $(".jsSliderMobileOnly");

            $sliderMobileOnly.each(function () {
                var $slider = $(this);
                var $sliderSlides = $slider.find(".slider__slides");
                var $sliderArrows = $slider.find(".slider__arrows");
                var $sliderDots = $slider.find(".slider__dots");
                var showSlides = parseInt($slider.attr("data-slidestoshow"))
                    ? parseInt($slider.attr("data-slidestoshow"))
                    : 1;

                $win.on("load resize", function () {
                    if (
                        mobileView() &&
                        !$sliderSlides.hasClass("slick-initialized")
                    ) {
                        $sliderSlides.slick({
                            arrows: true,
                            appendArrows: $sliderArrows,
                            dots: true,
                            appendDots: $sliderDots,
                            infinite: true,
                            slidesToShow: showSlides,
                            slidesToScroll: 1,
                            speed: 800,
                            adaptiveHeight: true,
                        });

                        setTimeout(function () {
                            $slider.find(".slider__slides").slick("refresh");
                        }, 1000);
                    }
                    if (
                        !mobileView() &&
                        $sliderSlides.hasClass("slick-initialized")
                    ) {
                        $sliderSlides.slick("unslick");
                    }
                });
            });
        }
    }

    // Equalize Heights
    // WP marks a custom-link menu item current-menu-item purely by matching
    // its URL (fragment stripped) against the current page, so it can't
    // tell "Completed" apart from "Now Selling" once the user is actually
    // at the #completed-projects hash. Re-point current-menu-item at
    // whichever subnav link's own hash matches the URL right now.
    function updateSecondaryNavFromHash() {
        var hash = window.location.hash;

        if (!hash) {
            return;
        }

        var $matched = $(".nav-secondary .menu:not(.menu--overview) > li").filter(
            function () {
                var href = $(this).children("a").attr("href") || "";
                return href.split("#")[1] === hash.slice(1);
            }
        );

        if ($matched.length) {
            $matched
                .addClass("current-menu-item")
                .siblings(".current-menu-item")
                .removeClass("current-menu-item");
        }
    }

    function equalizeHeightsOf() {
        function eqHeight($elem) {
            if (!$elem.length) {
                return;
            }

            if (!mobileView()) {
                var maxHeight = 0;

                $elem.outerHeight("auto");

                $elem.each(function () {
                    var elemHeight = $(this).outerHeight();

                    if (maxHeight > elemHeight) {
                        maxHeight = maxHeight;
                    } else {
                        maxHeight = elemHeight;
                    }
                });

                $elem.outerHeight(maxHeight);
            } else {
                setTimeout(function () {
                    $elem.each(function () {
                        $elem.outerHeight("auto");
                    });
                }, 250);
            }
        }

        for (var i = 0; i < arguments.length; i++) {
            eqHeight(arguments[i]);
        }
    }

    // Google Maps

    window.initMap = function () {
        if ($(".map").length) {
            googleMaps();
        }
    };

    function loadGoogleMaps() {
        var scriptTag = document.createElement("script");
        scriptTag.setAttribute("type", "text/javascript");
        scriptTag.setAttribute(
            "src",
            "https://maps.googleapis.com/maps/api/js?key=AIzaSyA3ZR90bRiwr4ZpAroND55hYnHf25hFeLE&callback=initMap"
        );
        // scriptTag.setAttribute("src","https://maps.googleapis.com/maps/api/js?key=AIzaSyDFqXGpw9dR41CRbOq3h32HUbAqsxQyHOA&callback=initMap");

        (
            document.getElementsByTagName("head")[0] || document.documentElement
        ).appendChild(scriptTag);
    }

    // Load AJAX data
    function loadAjax(filePath) {
        return $.ajax({
            async: false,
            global: false,
            url: filePath,
        }).responseJSON;
    }

    function googleMaps() {
        var thisMap = 0;
        $(".map").each(function () {
            var $map = $(this);
            var data_url = $map.data("mapdata");
            var mapData = loadAjax(data_url);
            var markers = [];
            var markersLength = mapData.markers.length;
            var icon;
            var icon_label;
            //console.log(mapData);

            if (mobileView()) {
                map[thisMap] = new google.maps.Map(
                    $map.get(0),
                    mapData.mapOptionsMobile
                );
                $map.attr("data-map-number", thisMap);
                icon = mapData.mapOptionsMobile.icon;
            } else {
                map[thisMap] = new google.maps.Map(
                    $map.get(0),
                    mapData.mapOptions
                );
                $map.attr("data-map-number", thisMap);
                icon = mapData.mapOptions.icon;
            }

            // contact page map

            if (!$map.hasClass("map--filter")) {
                for (var i = 0; i < markersLength; i++) {
                    if (typeof icon !== "object") {
                        var icon_url = data_url
                            .replace("files/mapdata2.json", "")
                            .replace("files/mapdata3.json", "")
                            .replace("files/mapdata_locations.json", "");

                        // Prefer a marker's mobile-specific icon (smaller
                        // asset) when present, so it isn't always clobbered
                        // by the full-size icon below on mobile viewports.
                        var icon_filename = mapData.markers[i].icon;
                        if (mobileView() && mapData.markers[i].icon_mobile) {
                            icon_filename = mapData.markers[i].icon_mobile;
                        }

                        icon = icon_url + "images/" + icon_filename;

                        //console.log(mapData.markers[i]);
                    }
                    var marker = new google.maps.Marker({
                        position: mapData.markers[i].position,
                        map: map[thisMap],
                        clickable: false,
                        icon: icon,
                        title: mapData.markers[i].title,
                        url:
                            "https://maps.google.com/?q=" +
                            mapData.markers[i].position.lat +
                            "," +
                            mapData.markers[i].position.lng,
                    });

                    google.maps.event.addListener(marker, "click", function () {
                        window.location.href = this.url;
                    });
                }
            } else {
                filterMarkers = function (category, mapID) {
                    var bounds = new google.maps.LatLngBounds();
                    for (i = 1; i < markers.length; i++) {
                        marker = markers[i];

                        if (
                            marker.category == category ||
                            category.length == 0
                        ) {
                            marker.setVisible(true);
                            bounds.extend(marker.position);
                        } else {
                            marker.setVisible(false);
                        }
                        if (category == "show-all") {
                            marker.setVisible(true);
                            bounds.extend(marker.position);
                        }
                    }
                    map[mapID].fitBounds(bounds, 10);
                };

                var category_color = {
                    parklands: "#00b74f",
                    retail: "#ffc826",
                    cafes: "#ffadb7",
                    education: "#1cecd8",
                    transport: "#07272d",
                };

                // get correct image path using the json file
                var icon_url = data_url
                    .replace("files/mapdata2.json", "images/")
                    .replace("files/mapdata3.json", "images/")
                    .replace("files/mapdata_locations.json", "images/");

                for (var i = 0; i < markersLength; i++) {
                    if (mapData.markers[i].category != "all") {
                        iconTextColor = "#000";
                        if (mapData.markers[i].category == "transport")
                            iconTextColor = "#fff";
                        icon = {
                            path: google.maps.SymbolPath.CIRCLE,
                            fillOpacity: 1,
                            fillColor:
                                category_color[mapData.markers[i].category],
                            strokeOpacity: 0,
                            scale: 12,
                        };
                        icon_label = {
                            color: iconTextColor,
                            fontSize: "10px",
                            fontWeight: "600",
                            text: mapData.markers[i].icon_text,
                        };
                    } else {
                        icon = icon_url + mapData.markers[i].icon;
                        icon_label = "";
                    }
                    var marker = new google.maps.Marker({
                        position: mapData.markers[i].position,
                        map: map[thisMap],
                        icon: icon,
                        clickable: false,
                        label: icon_label,
                        zIndex: i + 10,
                        category: mapData.markers[i].category,
                    });

                    markers.push(marker);
                }
            }
            thisMap++;
        });

        $(".jsMapFilterNav").add($(".jsMapFilterNav ul")).removeClass("active");

        $(".jsMapFilterNav .btn-acc").on("click", function (e) {
            e.preventDefault();
            var filter = $(this).attr("data-filter"),
                $map = $(this)
                    .parents(".map-legend")
                    .find(".map__content .map"),
                mapID = $map.attr("data-map-number");
            if (
                $(this)
                    .closest(".accordion__section")
                    .hasClass("accordion__section--current")
            ) {
                filterMarkers("show-all", mapID);
            } else {
                filterMarkers(filter, mapID);
            }
        });
    }

    // Click Handlers

    function clickHandlers() {
        // Nav
        $(".btn-menu").on("click", function (e) {
            e.preventDefault();
            //console.log('btn menu');
            if ($(".modal--form").hasClass("show")) {
                //close the popup
                $(".modal").removeClass("show");
                $(".btn-menu").removeClass("modal-opened");
            } else {
                // toogle the nav

                $(".header").toggleClass("nav-visible");
                $(".btn-menu").toggleClass("nav-visible");
            }
        });

        $(".jsHasDropdown > a").on("click touchstart", function (e) {
            if (tabletView() && !mobileView()) {
                if (!$(this).parent().hasClass("dd-show")) {
                    e.preventDefault();

                    $(this)
                        .parent()
                        .addClass("dd-show")
                        .siblings()
                        .removeClass("dd-show");
                }
            }
        });

        $(".nav-secondary li a").on("click", function (e) {
            //e.preventDefault();
            if ($(this).hasClass("current-menu-item")) {
                e.preventDefault();

                if (!$(".nav-secondary.opened").length) {
                    $(".nav-secondary").addClass("opened");
                } else {
                    $(".nav-secondary").removeClass("opened");
                }
            }

            // $(this)
            //     .parent('li').addClass('active')
            //     .siblings().removeClass('active');
        });

        $(".completed-project-links li a").on("click", function (e) {
            e.preventDefault();
            $(".completed-projects").removeClass("active");
            $(".completed-projects").addClass("hidden");

            var selectedProject = $(this).data("link");

            $("." + selectedProject)
                .addClass("active")
                .removeClass("hidden");

            //$('.'+ selectedProject + '.jsSliderMain .slick-prev').trigger('click');
            var $slider = $("." + selectedProject + " .jsSliderMain");
            var $sliderSlides = $slider.find(
                ".slider__slides:not(.slick-initialized)"
            );
            var $sliderArrows = $slider.find(".slider__arrows");
            var $sliderDots = $slider.find(".slider__dots");

            // intro has dif args
            if ($slider.hasClass("slider-intro")) {
                var slider_args = {
                    arrows: false,
                    dots: true,
                    appendDots: $sliderDots,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    autoplay: false,
                    autoplaySpeed: 5000,
                };
            } else {
                var showSlides = parseInt($slider.attr("data-slidestoshow"))
                    ? parseInt($slider.attr("data-slidestoshow"))
                    : 1;
                var autoplaySlides = $slider.attr("data-autoplay")
                    ? $slider.attr("data-autoplay")
                    : false;

                var slider_args = {
                    arrows: true,
                    appendArrows: $sliderArrows,
                    dots: true,
                    appendDots: $sliderDots,
                    infinite: true,
                    slidesToShow: showSlides,
                    slidesToScroll: 1,
                    speed: 800,
                    responsive: [
                        {
                            breakpoint: 767,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1,
                            },
                        },
                    ],
                };
            }

            // unslick already created sliders
            $(".completed-projects .slider__slides.slick-initialized").slick(
                "unslick"
            );

            // re-initialise / initialise for each slide
            $sliderSlides.slick(slider_args);
        });

        $(".nav-secondary").on("click", function () {
            if (!$(".nav-secondary.opened").length) {
                $(".nav-secondary").addClass("opened");
            } else {
                $(".nav-secondary").removeClass("opened");
            }
        });

        $(".nav-secondary.opened .btn-expand").on("click", function (e) {
            e.preventDefault();

            $(".nav-secondary").removeClass("opened");
        });

        // Popovers in Section-plan

        $(".popover__btn, .popover__btn a").on("click", function (e) {
            e.preventDefault();
            $(this)
                .closest(".popover")
                .addClass(activeClass)
                .siblings()
                .removeClass(activeClass);
        });

        $(".section-plan .popover").hover(function (e) {
            e.preventDefault();
            var $this = $(this);

            $(".res-hover").removeClass("res-hover--active");

            if ($this.hasClass("popover--residence1")) {
                $(".res-hover--1").addClass("res-hover--active");
            } else if ($this.hasClass("popover--residence2")) {
                $(".res-hover--2").addClass("res-hover--active");
            } else {
                if ($this.hasClass("popover--residence3")) {
                    $(".res-hover--3").addClass("res-hover--active");
                }
            }
        });

        // Popovers Discover Precincts (mobile: dot tap opens full-screen details)

        $(".popover-residence .popover__btn").on("click", function (e) {
            if (!mobileView()) {
                return;
            }

            e.preventDefault();
            e.stopPropagation();

            $(this)
                .closest(".popover-residence")
                .addClass(activeClass)
                .siblings(".popover-residence")
                .removeClass(activeClass);
        });

        $(".popover-residence .popover__close").on("click", function (e) {
            e.preventDefault();

            $(this).closest(".popover-residence").removeClass(activeClass);
        });

        // Popovers Project
        // $(".popover--project .popover__btn").on("click", function (e) {
        //     var $this = $(this);
        //     var popoverNumber = $this
        //         .closest(".popover--project")
        //         .data("popover");

        //     $this
        //         .closest(".project-about")
        //         .find(
        //             '.accordion [data-popover="' + popoverNumber + '"] .btn-acc'
        //         )
        //         .trigger("click");

        //     $(this)
        //         .closest(".popover--project")
        //         .addClass(activeClass)
        //         .siblings()
        //         .removeClass(activeClass);
        // });

        // Form Message

        // peader - commenting out burgers code - mimicing gf functionality

        // $('.form-register:not(.jsFormSteps) .gform_button').on('click', function(e) {
        //     e.preventDefault();

        //     $(this).closest('.form-register').addClass('show-message');

        //     setTimeout(function() {
        //         $('.form-register').removeClass('show-message');
        //     }, 5000);
        // });

        // Form Steps

        // $('.jsFormSteps .gform_button').on('click', function(e) {
        //     e.preventDefault();

        //     $(this).closest('.form__step')
        //         .removeClass('active')
        //         .next().addClass('active');
        // });

        // load article content

        $doc.on("click", ".btn--load-more-articles", function (e) {
            e.preventDefault();

            var $this = $(this);
            var $actions_container = $this.parent();

            var exclude = $this.data("exclude");
            var filters = $this.data("filters");

            ajaxSubmit(filters, exclude, $this);

            $this.parent().addClass("loading");
        });

        // filter search

        $(".search .search__btn").on("click", function (e) {
            e.preventDefault();

            var $this = $(this);
            var $search_cols = $this.closest(".search__cols");
            var filters = {};
            var exclude = "";

            //create filters
            if (
                $search_cols.find("#filter_date option:selected").text()
                    .length > 0
            ) {
                filters["filter_date"] = $search_cols
                    .find("#filter_date option:selected")
                    .val();
            }

            if (
                $search_cols.find("#filter_category option:selected").text()
                    .length > 0
            ) {
                filters["filter_category"] = $search_cols
                    .find("#filter_category option:selected")
                    .val();
            }

            if ($search_cols.find("#filter_keyword").val().length > 0) {
                filters["filter_keyword"] = $search_cols
                    .find("#filter_keyword")
                    .val();
            }

            ajaxSubmit(filters, exclude, $this);
        });

        // clear filters
        // $('.btn-clear').on('click', function(e){
        //     e.preventDefault();

        //     var $this = $(this);
        //     var $search_cols = $this.closest('.search__cols');

        //     // clear inputs
        //     $search_cols.find('#filter_date').val($("#filter_date option:first").val());
        //     $search_cols.find('#filter_category').val($("#filter_category option:first").val());
        //     $search_cols.find('#filter_keyword').val('');
        // });

        function ajaxSubmit(filters, exclude, $this) {
            var $container = $(".articles--news .articles__body .cols");
            var filtered_posts = false;

            if ($this.hasClass("search__btn")) {
                filtered_posts = true;
            }

            // filter code
            if (filtered_posts == true) {
                $container.addClass("loading").empty();
            } else {
                $this.parent().addClass("loading");
            }

            $.ajax({
                url: ajaxurl,
                type: "POST",
                data: {
                    action: "filter_news",
                    filters: filters,
                    exclude: exclude,
                },
                success: function (data) {
                    //console.log(data);
                    var elements = $(data);
                    $container.append(elements);

                    animateElements();

                    if (filtered_posts == true) {
                        $container.removeClass("loading");
                    } else {
                        $this.parent().addClass("loaded");
                    }
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    console.log((jqXHR, textStatus, errorThrown));
                },
            });
        }

        // Modals

        $doc.on("click", ".jsRegister a", function (e) {
            e.preventDefault();

            // $('.jsFormSteps').find('.form__step--1')
            //     .addClass('active')
            //     .siblings().removeClass('active');

            $(".modal--form").toggleClass("show");
            $(".btn-menu").addClass("modal-opened");
        });

        $(".jsBtnCloseModal").on("click", function (e) {
            e.preventDefault();
            $(".modal").removeClass("show");
        });
    }

    function initAcc() {
        // Hide the inactive sections
        $(".jsAcc .accordion__section")
            .not(".accordion__section--current")
            .find(".accordion__body")
            .hide();

        // Handle the show/hide logic
        $(".jsAcc").on("click", ".accordion__head .btn-acc", function (e) {
            e.preventDefault();

            var $this = $(this);

            $(this)
                .parent()
                .next()
                .stop()
                .slideToggle()
                .parent()
                .toggleClass("accordion__section--current")
                .siblings()
                .removeClass("accordion__section--current")
                .find(".accordion__body")
                .slideUp();

            if ($(this).closest(".jsAcc").hasClass("jsAccProject")) {
                var popoverNumber = $this
                    .closest(".accordion__section")
                    .data("popover");

                $this
                    .closest(".project-about")
                    .find(
                        '.project__map [data-popover="' + popoverNumber + '"]'
                    )
                    .toggleClass(activeClass)
                    .siblings()
                    .removeClass(activeClass);
            }
        });
    }

    function animateElements() {
        $(".fade-on-load").each(function (e) {
            var $animatedContainer = $(this);

            $animatedContainer.addClass("loaded");
        });
        // Group Animations
        $("[data-group]").each(function () {
            var $this = $(this);
            var elemGroup = $this.data("group");

            if (elemGroup !== group) {
                index = 0;
                group = elemGroup;
            }

            $this.css({
                transitionDelay: "" + 0.2 * index++ + "s",
            });
        });
    }

    function revealOnLoad() {
        var winST = $win.scrollTop();
        var prevAnimated;
        var transitionDelay = 0.2;

        $(".animate").each(function (e) {
            var $animatedContainer = $(this);

            if (
                $animatedContainer.offset().top <
                $win.scrollTop() + $win.height() - 100
            ) {
                $animatedContainer.addClass("animated");
            }
        });

        function init($elements) {
            $elements.each(function () {
                var $this = $(this);
                var delay = $this.parent().attr("data-delay");

                if (prevAnimated != null) {
                    if ($this.offset().top === prevAnimated.offset().top) {
                        $this.css({
                            "transition-delay": transitionDelay + "s",
                        });
                        transitionDelay += 0.3;
                    } else {
                        if ($this.parent().hasClass("fast")) {
                            transitionDelay = 0;
                            $this.css({
                                "transition-delay": transitionDelay + "s",
                            });
                            transitionDelay += 0.1;
                        } else {
                            transitionDelay = 0.3;
                            $this.css({
                                "transition-delay": transitionDelay + "s",
                            });
                            transitionDelay += 0.3;
                        }
                    }
                }

                if (
                    $win.scrollTop() + $win.height() >
                    $this.offset().top - 150
                ) {
                    if ($this.parent().hasClass("delay")) {
                        setTimeout(function () {
                            $this.addClass("in-view");
                        }, delay);
                    } else {
                        $this.addClass("in-view");
                    }
                }

                prevAnimated = $this;
            });
        }

        init($(".js-reveal"));
        init($(".js-reveal-content").children());
    }

    function fixedHeader() {
        headerH = $(".header").outerHeight();

        var winScroll = $win.scrollTop();
        var scrolled = winScroll > headerH;

        if (!mobileView()) {
            $(".header").toggleClass("header-fixed", scrolled);
        } else {
            $(".header").removeClass("header-fixed");
        }
    }

    $doc.ready(function () {
        clickHandlers();
        initSliders();
        initAcc();
        revealOnLoad();
        animateElements();
        loadGoogleMaps();
        updateSecondaryNavFromHash();
    });

    $win.on("hashchange", updateSecondaryNavFromHash);

    $doc.on("click touchstart", function (e) {
        var $target = $(e.target);

        if (!$target.closest(".header.nav-visible, .btn-menu").length) {
            $(".header").removeClass("nav-visible");
            $(".btn-menu").removeClass("nav-visible");
        }
        if (!$target.closest(".popover:not(.popover--project)").length) {
            $(".popover").removeClass(activeClass);
        }
        if (!$target.closest(".popover-residence").length) {
            $(".popover-residence").removeClass(activeClass);
        }
        if (!$target.closest(".jsHasDropdown > a, .jsHasDropdown").length) {
            $(".jsHasDropdown").removeClass("dd-show");
        }
        // if(!$target.closest('.modal .modal__inner, .jsBtnCloseModal, .jsRegister').length) {
        //     e.stopPropagation();

        //     console.log('close modal');
        // }
    });

    $win.on("load scroll", function () {
        fixedHeader();

        //if (!tabletView()) {
        revealOnLoad();
        animateElements();
        //}
    });

    $win.on("load resize", function () {
        fixedHeader();

        setTimeout(function () {
            equalizeHeightsOf(
                $(".profile .profile__content"),
                $(".jsEqArticleContent .article__content"),
                $(".jsEqSlides .slider__slide")
            );
        }, 250);
    });

    $win.on("load", function () {
        // Youtube API
        var players = [];

        if ($(".video-container .video__media").length) {
            $(".video-container .video__media").each(function () {
                var $this = $(this);
                var $playVideo = $this.siblings(".video__btn");
                var $parent = $this.closest(".video-container");
                var videoId = $this.data("videoid");
                var player = new YT.Player(this, {
                    events: {
                        onStateChange: function (data) {
                            if (data.data == 0) {
                                $parent.removeClass(activeClass);
                            }
                        },
                    },
                    videoId: videoId,
                });

                players.push(player);

                $playVideo.on("click", function (e) {
                    e.preventDefault();
                    if (typeof player != undefined) player.playVideo();

                    $parent.addClass(activeClass);
                });

                $doc.on("click touchstart", function (e) {
                    var $target = $(e.target);

                    if ($(".video-container.active").length) {
                        if (
                            !$target.closest(".video-container.active").length
                        ) {
                            $parent.removeClass(activeClass);

                            $(player).each(function () {
                                this.stopVideo();
                            });
                        }
                    }
                });
            });
        }

        // for 'file' videos lets use the dom play method
        $file_videos = $(".video-container--file");

        if ($file_videos.length > 0) {
            $file_videos.each(function () {
                var $this = $(this);
                var video_id = $this.find("video").attr("id");

                if (video_id !== "undefined") {
                    var video_element = document.getElementById(video_id);

                    $this.find(".video__btn").on("click", function (e) {
                        e.preventDefault();
                        video_element.play();
                        $this.addClass(activeClass);
                    });

                    $doc.on("click touchstart", function (e) {
                        var $target = $(e.target);

                        if ($(".video-container.active").length) {
                            if (
                                !$target.closest(".video-container.active")
                                    .length
                            ) {
                                $this.removeClass(activeClass);
                                var video_element =
                                    document.getElementById(video_id);

                                if (
                                    video_element !== "undefined" &&
                                    video_element !== null
                                ) {
                                    video_element.pause();
                                }
                            }
                        }
                    });
                }
            });
        }

        // for dev let's delete this cookie so the popup shows each time
        // delete_cookie("cookiename");

        // get cookie
        var cookiename = getCookie("cookiename");

        if (cookiename != "cookie_notice_dismiss") {
            if ($("body").hasClass("home")) {
                function show_form() {
                    $(".modal--form").addClass("show");
                    $(".btn-menu")
                        .addClass("modal-opened")
                        .addClass("modal-form--opened");
                }

                setTimeout(show_form, 5000);
            }

            // create cookie
            set_cookie("cookie_notice_dismiss", 0);
        }

        $(".jsBtnCloseModal").on("click", function (e) {
            e.preventDefault();

            // create cookie
            set_cookie("cookie_notice_dismiss", 0);
        });
    });

    function delete_cookie(name) {
        document.cookie =
            name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
    }

    function set_cookie(name, value) {
        //console.log('create cookie - ' + name );
        document.cookie =
            "cookiename=" + name + "; expires=" + value + "; path=/";
    }

    function getCookie(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(";");
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == " ") {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    function window_width() {
        var myWidth = 0;
        if (typeof window.innerWidth == "number") myWidth = window.innerWidth;
        else if (
            document.documentElement &&
            document.documentElement.clientWidth
        )
            myWidth = document.documentElement.clientWidth;
        else if (document.body && document.body.clientWidth)
            myWidth = document.body.clientWidth;
        return myWidth;
    }

    function window_height() {
        var myHeight = 0;
        if (typeof window.innerHeight == "number")
            myHeight = window.innerHeight;
        else if (
            document.documentElement &&
            document.documentElement.clientHeight
        )
            myHeight = document.documentElement.clientHeight;
        else if (document.body && document.body.clientHeight)
            myHeight = document.body.clientHeight;
        return myHeight;
    }
})(jQuery, window, document);
